import { Box } from "@mui/material";
import ReactJson from "react-json-view";

const jsonLines = (data) =>
  JSON.stringify(data, null, 2)
    .split("\n")
    .filter((v) => v.trim().length > 1).length;

export const JsonStyled = (props) => {
  if (!props.data) {
    return null;
  }

  if (
    !props.collapsed &&
    props.maxLines &&
    props.maxLines < jsonLines(props.data)
  ) {
    props = Object.assign({}, props, { collapsed: true });
  }

  const style = {
    maxHeight: "50vh",
    overflowY: "auto",
  };

  return (
    <Box style={style}>
      <ReactJson src={props.data} {...props} />
    </Box>
  );
};
JsonStyled.defaultProps = {
  name: null,
  collapsed: false,
  enableClipboard: false,
  displayDataTypes: false,
  theme: "google",
  style: { padding: "1em", borderRadius: "25px" },
};
